import { LANGS, useLang, useSwitchLang } from '@/i18n';

/* Переключатель языка. Кнопки, а не выпадающий список: языков мало, и на
 * телефоне попасть пальцем в кнопку проще, чем открыть select.
 * Смена языка меняет только адрес — экран и прогресс остаются на месте. */
export const LanguageSwitcher = ({ className = '', variant = 'light' }) => {
  const lang = useLang();
  const switchLang = useSwitchLang();
  const codes = Object.keys(LANGS);

  const activeCls =
    variant === 'light'
      ? 'bg-white/25 text-primary-foreground'
      : 'bg-primary/10 text-primary';
  const idleCls =
    variant === 'light'
      ? 'text-primary-foreground/60 hover:text-primary-foreground'
      : 'text-muted-foreground hover:text-foreground';

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      {codes.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => switchLang(code)}
          aria-label={LANGS[code].label}
          aria-current={code === lang ? 'true' : undefined}
          className={`px-2 py-1 rounded-md text-[11px] font-bold uppercase tracking-wide transition-colors duration-150 ${
            code === lang ? activeCls : idleCls
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
};
